import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import jwtToken from "jwt-decode";
// import axios from "axios";
import axios from "../../GlobalAPIErrorHandler/axiosConfig";
import { setApiMessage } from "./globalApiMessageSlice";
import { setLoading } from "./loading";

// getUIAppUserAttributes
const getUIAppUserAttributesSync = async (dataVal) => {
  if (dataVal) {
    try {
      const token = jwtToken(dataVal?.responseBody);
      const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
      const { data } = await axios.get(
        `${API_HOST_LOGIN}/getUIAppUserAttributes?appUserId=${token.AppUserId}`,
        {
          headers: {
            jwtToken: dataVal?.responseBody,
          },
        }
      );
      if (data) {
        return data?.responseBody;
      }
    } catch {
      console.log("error");
    }
  }
};

const getUserPrivilege = async (dataVal) => {
  if (dataVal) {
    try {
      const token = jwtToken(dataVal?.responseBody);
      const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
      const { data, status } = await axios.get(
        `${API_HOST_LOGIN}/getPrivileges?appUserId=${token.AppUserId}`,
        {
          headers: {
            jwtToken: dataVal?.responseBody,
          },
        }
      );

      //dispatch(setApiMessage());
      if (data) {
        return data?.responseBody;
      }
    } catch (error) {}
  }
};
const getooboUIAppUserAttributeSync = async (payload) => {
  try {
    // const token = jwtToken(dataVal?.responseBody);
    const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
    const { data } = await axios.get(
      `${API_HOST_LOGIN}/getUIAppUserAttributes?appUserId=${payload?.userInfo?.appUserId}`,
      {
        headers: {
          jwtToken: payload?.token,
        },
      }
    );
    if (data) {
      return data?.responseBody;
    }
  } catch {
    console.log("error");
  }
};

const getooboUIAppUserDetailsSync = async (payload) => {
  try {
    const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
    const { data } = await axios.get(
      `${API_HOST_LOGIN}/getUIAppUserDetails?appUserId=${payload?.userInfo?.appUserId}`,
      {
        headers: {
          jwtToken: payload?.token,
        },
      }
    );
    if (data) {
      return data?.responseBody;
    }
  } catch {
    console.log("error");
  }
};
const getooboPrivilege = async (payload) => {
  try {
    const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
    const { data, status } = await axios.get(
      `${API_HOST_LOGIN}/getPrivileges?appUserId=${payload?.userInfo?.appUserId}`,
      {
        headers: {
          jwtToken: payload?.token,
        },
      }
    );

    //dispatch(setApiMessage());
    if (data) {
      return data?.responseBody;
    }
  } catch (error) {}
};

export const saveEFullfilmentOptOutDetail = async (payload) => {
  try {
    setLoading(true);
    const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}10522`;
    const { data, status } = await axios.get(
      `${API_HOST_LOGIN}/saveEfulfillmentOptout/${payload?.companyNo}?emailAddress=${payload?.email}&status=${payload?.status}&customToken=${payload?.token}`
    );

    //dispatch(setApiMessage());
    if (data) {
      return data?.responseBody;
    }
  } catch (error) {
    return error.response.data;
  } finally {
    setLoading(false);
  }
};

export const ooboLoginThunk = createAsyncThunk(
  "login/ooboLoginThunk",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login, accountManage } = getState();
      const data = { ...arg, userInfo: arg };
      const userInfo = await getooboUIAppUserAttributeSync(data);
      const userPrivilege = await getooboPrivilege(data);
      const userDetail = await getooboUIAppUserDetailsSync(data);
      if (userInfo) {
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      }
      dispatch(setApiMessage());
      return {
        token: login?.token,
        userInfo,
        userPrivilege,
        userDetail,
        roleId: accountManage?.user?.roleId,
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getClientThunk = createAsyncThunk(
  "login/getClientThunk",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;

    try {
      const { login } = getState();
      const { companyNumber } = login;

      const { data } = await axios.get(
        `${API_HOST_LOGIN}/setup/clientConfig/key/siteUrlCompanyMapping`
      );
      if (!window.location.host.includes("localhost")) {
        let existingKey = null;
        await new Promise((resolve, reject) => {
          if (companyNumber) {
            existingKey = Object.keys(data).filter((value) =>
              value.includes(companyNumber)
            )[0];
            resolve(existingKey);
          } else {
            resolve(null);
          }
        });
        if (existingKey && window.location.host === data[existingKey]) {
          return {
            clientData: data,
            companyNumber: companyNumber,
            companyUrl: window.location.host,
          };
        } else {
          const companyNumberItem = Object.entries(data).filter(
            (value) => value[1] === window.location.host
          );
          if (companyNumberItem.length) {
            const cN = companyNumberItem[0][0].split("-")[0];
            const cU = data[companyNumberItem[0][0]];
            return { clientData: data, companyNumber: cN, companyUrl: cU };
          }
        }
      }

      return {
        clientData: data,
        // companyNumber: "1286",
        // companyNumber: "0956",
        // companyNumber: "0831",
        companyNumber: "1286",
        // companyNumber: "1308",
        // companyNumber: "1305",
        //  companyNumber: "0751",
        companyUrl: "localhost:8080",
      };
    } catch (error) {
      console.log(error);
      return rejectWithValue(API_HOST_LOGIN);
    }
  }
);
// export const getCategoryList = createAsyncThunk(
//   "search/getCategoryList",
//   async (arg, { getState, rejectWithValue, dispatch }) => {
//     try {
//       const { login } = getState();
//       const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_search}`;
//       if (login.token) {
//         const { data } = await axios.post(
//           `${API_HOST_SEARCH}/listCategories`,
//           {
//             companyNumber: login.companyNumber,
//             userInfo: login?.userInfoAttr?.userInfo,
//           },
//           {
//             headers: {
//               jwtToken: login.token,
//             },
//           }
//         );
//         dispatch(setApiMessage());
//         return data?.responseBody;
//       }
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   }
// );
export const postLoginThunk = createAsyncThunk(
  "login/postLogin",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login, accountManage } = getState();
      const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_login}`;
      const { data, status } = await axios.post(
        `${API_HOST_LOGIN}/loginUserbyComp`,
        arg
      );

      const userInfo = await getUIAppUserAttributesSync(data);
      // const userPrivilege = await getUserPrivilege(data);
      const userPrivilege = await userInfo?.userInfo?.privileges;
      if (userInfo) {
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      }
      dispatch(setApiMessage());
      return {
        data,
        userInfo,
        userPrivilege,
        status,
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const postSsoLoginThunk = createAsyncThunk(
  "login/postssoLogin",
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_login}`;
      const { data, status } = await axios.post(
        `${API_HOST_LOGIN}/ssologinUserbyComp`,
        arg
      );

      const userInfo = await getUIAppUserAttributesSync(data);
      const userPrivilege = await getUserPrivilege(data);
      if (userInfo) {
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      }
      dispatch(setApiMessage());
      return {
        data,
        userInfo,
        userPrivilege,
        status,
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const postLoginThunkUpdated = createAsyncThunk(
  "login/postLogin",
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const data = { ...arg };
      const status = data?.status == "success" ? 200 : 400;
      const userInfo = await getUIAppUserAttributesSync(data);
      // const userPrivilege = await getUserPrivilege(data);
      const userPrivilege = await userInfo?.userInfo?.privileges;
      if (userInfo) {
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      }
      dispatch(setApiMessage());
      return {
        data,
        userInfo,
        userPrivilege,
        status,
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const postChangePasswordLinkThunk = createAsyncThunk(
  "login/postChangePasswordLink",
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const API_HOST_PASSWORD = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
      const { data } = await axios.post(`${API_HOST_PASSWORD}/sendLink`, arg);
      const { responseBody = null } = data;
      if (responseBody) {
        const { errMsg } = responseBody;
        dispatch(setApiMessage({ status: "success", message: errMsg }));
      }
      return data;
    } catch (error) {
      dispatch(setApiMessage({ status: "fail", message: error.message }));
      return rejectWithValue(error.message);
    }
  }
);
export const postChangePasswordSubmitThunk = createAsyncThunk(
  "login/postChangePasswordSubmit",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const API_HOST_PASSWORD = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
      const { data } = await axios.post(
        `${API_HOST_PASSWORD}/forgotPasswordSubmit`,
        arg.payload,
        {
          headers: {
            jwtToken: arg.token,
          },
        }
      );
      if (data?.responseBody) {
        dispatch(
          setApiMessage({ status: "success", message: data?.responseBody })
        );
      }

      return data;
    } catch (error) {
      dispatch(setApiMessage({ status: "fail", message: error.message }));

      return rejectWithValue(error.response.data);
    }
  }
);
export const getUserInfoThunk = createAsyncThunk(
  "login/getUserInfo",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_user}`;
    try {
      const { login } = getState();
      if (login.token) {
        const { AppUserId } = login.decodedTokenObject;
        const { data } = await axios.get(
          `${API_HOST_LOGIN}/getUserInfo?appUserId=${AppUserId}`,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        dispatch(setApiMessage());

        return data?.responseBody;
      }
    } catch (error) {
      return rejectWithValue(API_HOST_LOGIN);
    }
  }
);

export const getuserPrivileges = createAsyncThunk(
  "login/getuserPrivileges",
  async (arg, { rejectWithValue, dispatch, getState }) => {
    const { login } = getState();
    const { decodedTokenObject } = login;
    const { AppUserId } = decodedTokenObject;
    if (login.token) {
      try {
        const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
        const { data, status } = await axios.get(
          `${API_HOST_LOGIN}/getPrivileges?appUserId=${AppUserId}`,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );

        //dispatch(setApiMessage());
        return { data, status };
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  }
);

// login userinfo changes

export const getUIAppUserAttributes = createAsyncThunk(
  "login/getUIAppUserAttributes",
  async (arg, { rejectWithValue, dispatch, getState }) => {
    const { login } = getState();
    const { decodedTokenObject } = login;
    const { AppUserId } = decodedTokenObject;
    if (login.token) {
      try {
        const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
        const { data, status } = await axios.get(
          `${API_HOST_LOGIN}/getUIAppUserAttributes?appUserId=${AppUserId}`,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );

        //dispatch(setApiMessage());
        return { data, status };
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  }
);

//Iac active inactive users login
export const getIacRejectToLogin = createAsyncThunk(
  "login/getIacRejectToLogin",
  async (arg, { rejectWithValue, dispatch, getState }) => {
    const { login } = getState();
    const { decodedTokenObject } = login;
    const { AppUserId } = decodedTokenObject;
    if (login.token) {
      try {
        const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_search}`;
        const { data } = await axios.post(
          `${API_HOST_LOGIN}/iacRejectToLogin`,
          {
            ...arg,
          },
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        return data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  }
);

export const logUserDetails = createAsyncThunk(
  "login/logUserDetails",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const CAPTURE_USER_DETAILS = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}/saveErrorDetail`;
      return await axios.post(
        CAPTURE_USER_DETAILS,
        {
          ...payload,
        },
        {
          headers: {
            authorization: process.env.REACT_APP_Auth_token,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// export const errorDetailsCall = async (payload) => {
//   const apiUrl = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}/getErrorDetailSearch`;
//   return await axios.post(apiUrl,{...payload},{
//     headers: {
//       authorization: process.env.REACT_APP_Auth_token,
//       "Content-Type": "application/json",
//     },
//   });
// };

export const errorDetailThunk = createAsyncThunk(
  "login/errorDetailThunk",
  async (arg, { rejectWithValue, dispatch, getState }) => {
    const { login } = getState();
    if (login.token) {
      try {
        const apiUrl = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}/getErrorDetailSearch`;
        const { data } = await axios.post(
          apiUrl,
          {
            ...arg,
          },
          {
            headers: {
              authorization: process.env.REACT_APP_Auth_token,
              "Content-Type": "application/json",
            },
          }
        );
        return data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  }
);

//Reset-Password API
export const resetPasswordThunk = createAsyncThunk(
  "login/resetPasswordThunk",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    const {
      confirmNewPassword,
      currentPassword,
      newPassword,
      appUserId,
      jwtToken,
    } = arg;
    try {
      dispatch(setLoading(true));
      const API_HOST_LOGIN = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_password}`;
      const { data } = await axios.post(
        `${API_HOST_LOGIN}/changePassword`,
        {
          appUserId: appUserId,
          oldPassword: currentPassword,
          newPassword: newPassword,
          confirmPassword: confirmNewPassword,
        },
        {
          headers: {
            jwtToken,
          },
        }
      );
      if (data) {
        return data;
      }
      return;
    } catch (error) {
      dispatch(setApiMessage(error.response?.errorMessage));
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

const initialState = {
  clientData: null,
  data: [],
  apiStatusCode: null,
  isSuccess: false,
  isLoginSuccessFul: false,
  message: "",
  loading: false,
  username: "",
  isPasswordChangeSuccessful: false,
  token: "",
  currentRoute: "",
  decodedTokenObject: null,
  userInfo: null,
  companyNumber: "",
  // filterCategoryData: [],
  companyUrl: null,
  userPrivilege: [],
  errorDetails: [],
  loggedUserPrivilege: [],
  passwordLinkSendStatus: null,
  passwordLinkSendError: null,
  userInfoAttr: null,
  isActiveIacUser: "",
  isSsoLoginUser: false,
  ssoErrorMessage: "",
  oobo: false,
  needsAddressVerification: false,
};
const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setSsoLoginUser(state, { payload }) {
      state.isSsoLoginUser = payload;
    },
    setSsoErrorMessageFunc(state, { payload }) {
      state.ssoErrorMessage = payload;
    },
    clearSSOMsg(state) {
      state.ssoErrorMessage = "";
    },
    setCompanyUrl(state, { payload }) {
      state.companyUrl = payload;
    },
    setCompanyNumber(state, { payload }) {
      state.companyNumber = payload;
    },
    setCurrentRoute(state, { payload }) {
      state.currentRoute = payload;
    },
    resetLoginData: () => initialState,
    setUsername(state, action) {
      const { payload } = action;
      state.username = payload;
    },
    setToken(state, action) {
      const { payload } = action;
      state.token = payload;
    },
    setuserPrivilege(state, action) {
      const { payload } = action;
      state.userPrivilege = payload;
    },
    resetEmailErrorMsg(state, action) {
      state.passwordLinkSendStatus = null;
      state.passwordLinkSendError = null;
    },
    ssoLoginUser(state, { payload }) {
      state.loading = false;
      state.data = payload?.data;
      state.apiStatusCode = payload?.status;
      state.isLoginSuccessFul = true;
      state.token = payload?.data?.responseBody;
      state.decodedTokenObject = jwtToken(payload?.data?.responseBody);
      // state.userInfoAttr = payload?.userInfo;
      // state.userInfoDetail = payload?.userDetail?.person;
      // state.loggedUserPrivilege = payload?.userPrivilege;
      // state.userPrivilege = payload?.userPrivilege;
    },
    reloadOOBO(state, action) {
      state.oobo = false;
    },
    verifiedAddress(state) {
      state.needsAddressVerification = false;
    },
  },
  extraReducers: {
    // [getCategoryList.pending]: (state, payload) => {
    //   state.loading = true;
    //   state.filterCategoryData = [];
    // },
    // [getCategoryList.fulfilled]: (state, { payload = [] }) => {
    //   state.loading = false;
    //   state.filterCategoryData = payload;
    // },
    // [getCategoryList.rejected]: (state, payload) => {
    //   state.loading = false;
    //   state.filterCategoryData = [];
    // },
    [postLoginThunk.pending]: (state, payload) => {
      state.loading = true;
      state.data = [];
      state.isLoginSuccessFul = false;
      state.token = "";
    },
    [postLoginThunk.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.data = payload?.data;
      state.apiStatusCode = payload?.status;
      state.isLoginSuccessFul = true;
      state.token = payload?.data?.responseBody;
      state.decodedTokenObject = jwtToken(payload?.data?.responseBody);
      state.userInfoAttr = payload?.userInfo;
      state.userInfoDetail = payload?.userDetail?.person;
      state.loggedUserPrivilege = payload?.userPrivilege;
      state.userPrivilege = payload?.userPrivilege;
    },
    [postLoginThunk.rejected]: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
      state.apiStatusCode = payload?.status;
      state.isLoginSuccessFul = false;
      state.token = "";
    },
    [postLoginThunkUpdated.pending]: (state, payload) => {
      state.loading = true;
      // state.data = [];
      // state.isLoginSuccessFul = false;
      // state.token = "";
    },
    [postLoginThunkUpdated.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.data = payload?.data;
      state.message = payload?.data?.errorMessage;
      state.apiStatusCode = payload?.status;
      state.isLoginSuccessFul = true;
      state.token = payload?.data?.responseBody;
      state.decodedTokenObject = jwtToken(payload?.data?.responseBody);
      state.userInfoAttr = payload?.userInfo;
      state.userPrivilege = payload?.userPrivilege;
      state.currentPrivilege = payload?.userPrivilege;
      state.oobo = false;
      state.needsAddressVerification =
        payload?.userInfo?.userInfo?.needsAddressVerification;
    },
    [postLoginThunkUpdated.rejected]: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
      state.apiStatusCode = payload?.status;
      state.isLoginSuccessFul = false;
      state.token = "";
    },

    [ooboLoginThunk.pending]: (state, payload) => {
      state.loading = true;
      state.data = [];
      state.isLoginSuccessFul = false;
    },
    [ooboLoginThunk.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.userInfoAttr = payload?.userInfo;
      state.currentPrivilege = payload?.userPrivilege;
      state.userInfoDetail = payload?.userDetail?.person;
      if (!state.roleId) {
        state.roleId = payload?.roleId;
      }
      state.oobo = true;
    },
    [ooboLoginThunk.rejected]: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
      state.isLoginSuccessFul = false;
    },
    [postChangePasswordLinkThunk.pending]: (state, payload) => {
      state.loading = true;
      state.data = [];
      state.passwordLinkSendStatus = null;
      state.passwordLinkSendError = null;
    },
    [postChangePasswordLinkThunk.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
      state.passwordLinkSendStatus = payload?.status;
      state.passwordLinkSendError = payload?.errorMessage;
    },
    [postChangePasswordLinkThunk.rejected]: (state, payload) => {
      state.loading = false;
      state.message = "postChangePasswordSubmitThunk rejected";
      state.data = payload;
    },
    [postChangePasswordSubmitThunk.pending]: (state, payload) => {
      state.loading = true;
      state.data = [];
      state.isPasswordChangeSuccessful = false;
    },
    [postChangePasswordSubmitThunk.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
      state.isPasswordChangeSuccessful = true;
    },
    [postChangePasswordSubmitThunk.rejected]: (state, { payload }) => {
      state.loading = false;
      state.message = "postChangePasswordSubmitThunk rejected";
      state.data = payload;
      state.isPasswordChangeSuccessful = false;
    },
    [getUserInfoThunk.pending]: (state, payload) => {
      state.loading = true;
      state.userInfo = null;
    },
    [getUserInfoThunk.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.userInfo = payload;
    },
    [getUserInfoThunk.rejected]: (state, payload) => {
      state.loading = false;
      state.userInfo = null;
      state.message = "getUserInfoThunk rejected";
    },
    [getClientThunk.pending]: (state, payload) => {
      state.loading = true;
      state.clientData = null;
    },
    [getClientThunk.fulfilled]: (state, { payload }) => {
      state.companyNumber = payload?.companyNumber;
      state.companyUrl = payload?.companyUrl;
      state.loading = false;
      state.clientData = payload?.clientData;
    },
    [getClientThunk.rejected]: (state, payload) => {
      state.loading = false;
      state.clientData = null;
      state.message = "getUserInfoThunk rejected";
    },

    [getuserPrivileges.pending]: (state, payload) => {
      state.loading = false;
      state.userPrivilege = [];
      // state.message = "userPrivilege rejected";
    },
    [getuserPrivileges.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.userPrivilege = payload?.data?.responseBody;
      // state.message = "userPrivilege fulfilled";
    },
    [getuserPrivileges.rejected]: (state, payload) => {
      state.loading = false;
      state.userPrivilege = [];
      // state.message = "userPrivilege rejected";
    },
    [getUIAppUserAttributes.pending]: (state, payload) => {
      state.loading = false;
      state.userInfoAttr = null;
      // state.message = "userPrivilege rejected";
    },
    [getUIAppUserAttributes.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.userInfoAttr = payload?.data?.responseBody;
      // state.message = "userPrivilege fulfilled";
    },
    [getUIAppUserAttributes.rejected]: (state, payload) => {
      state.loading = false;
      // state.userPrivilege = null;
      // state.message = "userPrivilege rejected";
    },
    [errorDetailThunk.pending]: (state, payload) => {
      state.loading = true;
      state.errorDetails = [];
      // state.message = "userPrivilege rejected";
    },
    [errorDetailThunk.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.errorDetails = payload?.responseBody;
      // state.message = "userPrivilege fulfilled";
    },
    [errorDetailThunk.rejected]: (state, payload) => {
      state.loading = false;
    },

    [getIacRejectToLogin.pending]: (state) => {
      state.loading = true;
      state.message = "";
      state.isActiveIacUser = null;
    },
    [getIacRejectToLogin.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.isActiveIacUser = payload?.responseBody;
      state.message = payload?.errorMessage;
      // state.message = "Inactive Iac User";
      // state.isActiveIacUser = false;
    },
    [getIacRejectToLogin.rejected]: (state, { payload }) => {
      state.loading = false;
      state.isActiveIacUser = payload?.responseBody;
      state.message = payload?.errorMessage;
    },
    [logUserDetails.pending]: (state) => {},
    [logUserDetails.fulfilled]: (state, { payload }) => {},
    [logUserDetails.rejected]: (state, { payload }) => {},
  },
});
export const {
  setUsername,
  setToken,
  resetLoginData,
  setCurrentRoute,
  setCompanyNumber,
  setuserPrivilege,
  resetEmailErrorMsg,
  setSsoLoginUser,
  setSsoErrorMessageFunc,
  ssoLoginUser,
  clearSSOMsg,
  reloadOOBO,
  verifiedAddress,
} = loginSlice.actions;
export default loginSlice.reducer;